import type { ShippingEligibilityState } from '@/lib/types/shippingEligibilityState';

export const defaultShippingEligibilityState: ShippingEligibilityState = {
  eligibility: null,
  isLoading: false,
  lastFetch: null,
  error: null,
};
